import {
  BrandSelectionWidget,
  ProductCategorySelectionWidget,
  ProductUnitSelectionWidget,
} from 'components/FormWidget';

const uiSchema = () => ({
  category_id: {
    'ui:widget': ProductCategorySelectionWidget,
  },
  brand_id: {
    'ui:widget': BrandSelectionWidget,
  },
  unit_id: {
    'ui:widget': ProductUnitSelectionWidget,
  },
});

export default uiSchema;
